// Varsayılan site bilgileri. Admin panelinden (Firestore: settings/site) üzerine yazılabilir.
export const defaultSite = {
  name: "Mahir Usta Otogaz",
  shortName: "Mahir Usta",
  tagline: "LPG dönüşüm, bakım ve araç servisi",
  url: "https://mahirustaoto.com",
  email: "info@mahirustaoto.com",
  // TODO: Yeni sabit hat numarası belli olunca güncelleyin (admin panelinden de değiştirilebilir).
  phone: "0534 722 28 83",
  phoneHref: "+905347222883",
  whatsapp: "905347222883",
  address: {
    line1: "Merkez Mah. Devlet Karayolu Cad. No: 148 İç Kapı No: 1",
    line2: "Kaytazdere Beldesi / Altınova / Yalova",
    street: "Merkez Mah. Devlet Karayolu Cad. No: 148 İç Kapı No: 1",
    district: "Kaytazdere, Altınova",
    city: "Yalova",
    postalCode: "77700",
    country: "TR",
    mapsQuery:
      "Merkez Mah. Devlet Karayolu Cad. No:148 Kaytazdere Altınova Yalova",
  },
  hours: [
    { days: "Pazartesi – Cumartesi", time: "09:00 – 18:00" },
    { days: "Pazar", time: "Kapalı" },
  ],
  founder: {
    name: "Mahir Zirh",
    title: "Kurucu & Usta",
    experienceYears: 30,
    photo: "/images/about/mahir-zirh.jpg",
  },
  // Açılış duyurusu (admin panelinden kapatılabilir)
  announcement: {
    enabled: true,
    text: "Yeni yerimizde 28 Eylül'de hizmetinizdeyiz! Kaytazdere / Altınova / Yalova",
    link: "/hakkimizda",
    // Bu tarihten 30 gün sonra duyuru otomatik gizlenir.
    openingDate: "2026-09-28",
  },
  social: {
    instagram: "",
    facebook: "",
    google: "",
  },
  stats: [
    { value: "30+", label: "Yıl tecrübe" },
    { value: "22", label: "Nokta kalite kontrol" },
    { value: "2 yıl", label: "Montaj garantisi" },
  ],
};

export function mergeSite(overrides) {
  if (!overrides) return defaultSite;
  return {
    ...defaultSite,
    ...overrides,
    address: { ...defaultSite.address, ...(overrides.address || {}) },
    founder: { ...defaultSite.founder, ...(overrides.founder || {}) },
    announcement: {
      ...defaultSite.announcement,
      ...(overrides.announcement || {}),
    },
    social: { ...defaultSite.social, ...(overrides.social || {}) },
    hours: overrides.hours && overrides.hours.length ? overrides.hours : defaultSite.hours,
  };
}
